import { orderArray } from "helpers/orderArray"

export const GET_CONDITIONS = "GET_CONDITIONS"
export const NEW_CONDITION = "NEW_CONDITION"
export const MOD_CONDITION = "MOD_CONDITION"
export const DEL_CONDITION = "DEL_CONDITION"

const initialState = {
  conditions: [],
}

export const conditionsReducer = ( state = initialState, { type, payload } ) => {
  switch (type) {
    case GET_CONDITIONS:
      const conditionsData = payload.map(cond => {
        return {
          ...cond,
          value: cond.id,
          label: cond.name
        }
      })
      return {
        ...state,
        conditions: orderArray(conditionsData, 'label'),
      }
    case NEW_CONDITION:
      return {
        ...state,
        conditions: [{...payload}, ...state.conditions],
      }
    case MOD_CONDITION:
      const newConditions = state.conditions.map(cond => {
        return cond.value === payload.id ? { ...payload, value: payload.id, label: payload.name}  : cond 
      })
      return {
        ...state,
        conditions: newConditions,
      }
      // const idx = state.conditions.indexOf(condition => condition.value === payload.id)
      // debugger
      // if(idx !== -1) {
      //   const updateState = [...state.conditions]
      //   updateState[idx] = {
      //     label: payload.name,
      //     value: payload.id
      //   }
      //   debugger
      //   return {
      //     ...state,
      //     conditions: updateState,
      //   }
      // }
    case DEL_CONDITION:
      const filterState = state.conditions.filter(condition => condition.value !== payload)
      return {
        ...state,
        conditions: filterState,
      }
    default:
      return state;
  }
}